@if (!busy) {
  <div class="wm-l-newtest-container">
    <form class="form" [formGroup]="form">
      <div class="form-section">
        <div class="form-section-info">
          <h4>Test Information</h4>
          <div class="description">Set the name of the test.</div>
        </div>
        <div class="form-section-content">
          <div class="form-item">
            <h4 class="form-label">Name</h4>
            <div class="form-item-content">
              <input type="text" class="form-input" pInputText formControlName="name"/>
              <div class="wm-newtest-input-icon">
                @if (nameInvalid()) {
                  <fa-icon aria-hidden="true" [pTooltip]="name.length > 0 ? 'Name already exists' : 'Name must not be empty'" [tooltipZIndex]="'10000'" icon="exclamation-triangle" size="lg" class="error-icon"></fa-icon>
                }
              </div>
            </div>
          </div>
        </div>
        <!--      <div class="wm-l-newtest-controls">-->
        <!--        <button (click)="createTest()" [disabled]="!settingsValid()" pButton>-->
        <!--                {{data.btnLabel}}-->
        <!--        </button>-->
        <!--      </div>-->
      </div>
      <div class="form-section">
        <div class="form-section-info">
          <h4>Target Specification</h4>
          <div class="description">Define the pages to be checked.</div>
        </div>
        <div class="form-section-content">
          <div class="form-item">
            <div class="selection">
              <p-button (click)="selectTargets($event)">Select Targets</p-button>
              {{ selectedTargetsSummary() }}
            </div>
          </div>
        </div>
      </div>
<!--      <div class="form-section">-->
<!--        <div class="form-section-info">-->
<!--          <h4>Vehicle Specification</h4>-->
<!--          <div class="description">Specify browser used in test.</div>-->
<!--        </div>-->
<!--        <div class="form-section-content">-->
<!--          @if (availableBrowsers) {-->
<!--            <div class="form-item">-->
<!--              <wm-browserchooser (browserChosen)="setBrowser($event)" [browsers]="availableBrowsers" [simpleMode]="true" [deployedBrowsers]="undefined"-->
<!--                                 [initWithBrowser]="undefined" [clear]="" [filterLocale]="true" class="wm-m-newtest-refbrowser"></wm-browserchooser>-->
<!--            </div>-->
<!--          } @else {-->
<!--            <div class="spinner-container available-browsers-spinner">-->
<!--              <div class="spinner-centered">-->
<!--                <p-progressSpinner></p-progressSpinner>-->
<!--              </div>-->
<!--            </div>-->
<!--          }-->
<!--        </div>-->
<!--      </div>-->
      <div class="form-section">
        <div class="form-section-info">
          <h4>Specs</h4>
          <div class="description">Configure specifications to test.</div>
        </div>
        <div class="form-section-content">
          <div class="form-item">
            <h4 class="form-label">Choose Specs</h4>
            <div class="form-item-content">
              <div class="form-item-info">
                Select the specifications that should be checked in this test. You can select individual specs or spec groups (if defined in the project). If you select a spec group, all specs within that group will be included in the test.
              </div>
              <div class="selection">
                <p-button (click)="addSpecPopover.show($event)">Select Specs</p-button>
                {{ (form.value.selectedSpecs || []).length }} spec(s) selected.
                <p-popover [baseZIndex]="10000" appendTo="body" #addSpecPopover>
                  <wm-spec-chooser [projectId]="projectId" [useProjectSpecGroups]="true" (onSpecsSelected)="addSpecs($event)"></wm-spec-chooser>
                </p-popover>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="wm-l-newtest-advanced-toggle">
        <span (click)="toggleAdvancedSettings()">
          @if (!advancedSettingsShown) {
            <span>Show</span>
          }
          @if (advancedSettingsShown) {
            <span>Hide</span>
          }
          advanced settings
          @if (!advancedSettingsShown) {
            <fa-icon icon="caret-down"></fa-icon>
          }
          @if (advancedSettingsShown) {
            <fa-icon icon="caret-up"></fa-icon>
          }
        </span>
      </div>

      @if (advancedSettingsShown) {
        <div class="form-section">
          <div class="form-section-info">
            <h4>Advanced Settings</h4>
            <div class="description">Configure additional behavior that is not needed for most spec checks.</div>
          </div>
          <div class="form-section-content">
            <div class="form-item advanced-settings-info">
              <h4 class="form-label">Browser Automation</h4>
              <div class="form-item-content">
                <div class="form-item-info">
                  Configure automation helpers that run before facts are collected for the spec check.
                </div>
              </div>
            </div>
            <wm-automation-policy-editor formControlName="automationPolicy"></wm-automation-policy-editor>
          </div>
        </div>
      }

      <div class="runtest-controls">
        @if (!creatingTest) {
          <button pButton icon="true" label="Launch Test" (click)="createCheck(false)" [disabled]="!settingsValid()">
            <fa-icon icon="rocket" [fixedWidth]="true"></fa-icon>
          </button>
        }
        @if (creatingTest) {
          <button pButton icon="true" [label]="launchLabel" [disabled]="true">
            <fa-icon icon="sync-alt" animation="spin" [fixedWidth]="true"></fa-icon>
          </button>
        }
        @if (errorMsg) {
          <div class="error-msg">{{ errorMsg }}</div>
        }
      </div>
    </form>
  </div>
} @else {
  <div class="wm-l-newtest-container-loading">
    <div>
      <p-progressSpinner></p-progressSpinner>
    </div>
    <div>Loading...</div>
  </div>
}
